import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { toApiError } from "src/types/api";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";

export interface iSignupAutoUpdateState {
  isLoading: boolean;
  message: string;
  error: string;
  response: any;
}

const initialState: iSignupAutoUpdateState = {
  isLoading: false,
  message: "",
  error: "",
  response: null,
};

export const postSignupAutoUpdateState = createAsyncThunk(
  "POST_SIGNUP_AUTO_UPDATE",
  async (params: { update_approve: boolean; }, { rejectWithValue }) => {
    const djangoEndpoint = getDjangoEndpoint();
    const pathParam = "/auth/admin/signup-auto-update/";

    try {
      const response = await axiosInstance.post(
        `${djangoEndpoint}${pathParam}`,
        {
          update_approve : params.update_approve
        },
        {
          withCredentials: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Email check API error:", error);
      const apiError = toApiError(error);
      return rejectWithValue(apiError.response?.data || { message: apiError.message });
    }
  }
);

export const getSignupAutoUpdateSlice = createSlice({
  name: "signupAutoUpdate",
  initialState,
  reducers: {

    resetSignUpAutoUpdate: (state) => {
      state.isLoading = false;
      state.message = "";
      state.error = "";
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postSignupAutoUpdateState.pending, (state) => {
        state.isLoading = true;
        state.message = "";
        state.error = "";
      })
      .addCase(postSignupAutoUpdateState.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
        // state.error = "e"
        state.message =
          action.payload?.message ||
          action.payload?.detail ||
          action.payload?.result ||
          "";
      })
      .addCase(postSignupAutoUpdateState.rejected, (state, action) => {
        state.isLoading = false;
        state.response = null;
        state.error =
          (action.payload as any)?.message ||
          (action.payload as any)?.detail ||
          action.error.message ||
          "Email verification request failed.";
      });
  },
});

export const { resetSignUpAutoUpdate } = getSignupAutoUpdateSlice.actions;

export default getSignupAutoUpdateSlice.reducer;
